/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_Q3Inputs */

const en_to_yaml_faq_q3 = /** @type {(inputs: To_Yaml_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are comments preserved?`)
};

const ko_to_yaml_faq_q3 = /** @type {(inputs: To_Yaml_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주석은 보존되나요?`)
};

const ja_to_yaml_faq_q3 = /** @type {(inputs: To_Yaml_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントは保持されますか？`)
};

/**
* | output |
* | --- |
* | "Are comments preserved?" |
*
* @param {To_Yaml_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_q3 = /** @type {((inputs?: To_Yaml_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_q3(inputs)
	if (locale === "ko") return ko_to_yaml_faq_q3(inputs)
	return ja_to_yaml_faq_q3(inputs)
});